module.exports = __webpack_public_path__ + "static/media/ms_cover.cfb24a09.png";